import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import { DISABLE_MODAL_RETRIES } from '../../RequestManagerConstants';

class PurchaseNodeIdTask extends AbstractRequestTask {
    constructor(object_id = 0) {
        super();
        this.object_id = object_id;
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.user_token
        };
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/payway/paymentservice/v1/purchasednodeid/${this.object_id}`;
    }

    getParams() {
        const params = super.getParams();
        const paramsSend = {
            authpn: params.authpn,
            authpt: params.authpt,
            device_category: params.device_category,
            device_id: params.device_id,
            device_manufacturer: params.device_manufacturer,
            device_model: params.device_model,
            device_type: params.device_type,
            device_so: params.device_so,
            region: params.region
        }
        return paramsSend;   
    }

    isValid (data) {
        if(!data.node_id) {
            return false;
        }
        return true;
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }

    getShowErrorModal(){
        return DISABLE_MODAL_RETRIES;
    }
}

export default PurchaseNodeIdTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PurchaseNodeIdTask.js